<template>
  <Dialog :visible="visible" modal>
    <template #header>
      <p>{{ motivoDesconexao }}</p>
    </template>
    <p>
      {{ conteudoDesconexao }}
    </p>
    <template #footer>
      <div class="flex flex-row">
        <Button @click="disconnecButtonClick">
          OK
        </Button>
      </div>
    </template>
  </Dialog>

</template>
<script setup lang="ts">
import Dialog from "primevue/dialog";
const visible = defineModel<boolean>("show");
const motivoDesconexao = ref("");
const conteudoDesconexao = ref("")

const { $networkBus } = useNuxtApp();


$networkBus.on("disconnected", ({ conteudo, motivo }) => {
  console.log("Descontectado");
  visible.value = true;
  motivoDesconexao.value = motivo;
  conteudoDesconexao.value = conteudo;
});

// const props = defineProps<{ msg: string }>();

function disconnecButtonClick() {
  visible.value = false;
  motivoDesconexao.value = "";
  conteudoDesconexao.value = "";
}

</script>
